﻿

(() => {
    angular.module('fliptoWeb')
        .controller('PrestayCtrl', [
        function () {


        }]);
})()
